import { CustomerMarkers } from '@enums/marker-types.enums';

export const START_MARKERS = [
  {
    time: 0.0,
    text: CustomerMarkers.START,
  },
  {
    time: 1.0,
    text: CustomerMarkers.START_END,
  },
];

export const WELCOME_MARKERS = [
  {
    time: 1.05,
    text: CustomerMarkers.WELCOME,
  },
  {
    time: 4.0,
    text: CustomerMarkers.WELCOME_END,
  },
];

export const RELAX_MARKERS = [
  {
    time: 5.0,
    text: CustomerMarkers.RELAX,
  },
  {
    time: 8.0,
    text: CustomerMarkers.RELAX_END,
  },
];

export const BOOKMARK_KNOW_MARKERS = [
  {
    time: 9.0,
    text: CustomerMarkers.BOOKMARK_KNOW,
  },
  {
    time: 14.0,
    text: CustomerMarkers.BOOKMARK_KNOW_END,
  },
];

export const BOOST_YOUR_KNOWLEDGE_MARKERS = [
  {
    time: 16.01,
    text: CustomerMarkers.BOOST_YOUR_KNOWLEDGE,
  },
  {
    time: 20.12,
    text: CustomerMarkers.BOOST_YOUR_KNOWLEDGE_END,
  },
];

export const COMMUNITY_PART_1_MARKERS = [
  {
    time: 22.0,
    text: CustomerMarkers.COMMUNITY_PART_1,
  },
  {
    time: 27.0,
    text: CustomerMarkers.COMMUNITY_PART_1_END,
  },
];

export const COMMUNITY_PART_2_MARKERS = [
  {
    time: 29.0,
    text: CustomerMarkers.COMMUNITY_PART_2,
  },
  {
    time: 32.15,
    text: CustomerMarkers.COMMUNITY_PART_2_END,
  },
];

export const EVENTS_MARKERS = [
  {
    time: 34.0,
    text: CustomerMarkers.EVENTS,
  },
  {
    time: 41.0,
    text: CustomerMarkers.EVENTS_END,
  },
];

export const EDUCATION_MARKERS = [
  {
    time: 43.0,
    text: CustomerMarkers.EDUCATION,
  },
  {
    time: 52.18,
    text: CustomerMarkers.EDUCATION_END,
  },
];

export const CONTACT_US_MARKERS = [
  {
    time: 54.16,
    text: CustomerMarkers.CONTACT_US,
  },
  {
    time: 60.0,
    text: CustomerMarkers.CONTACT_US_END,
  },
];

export const SUMMARY_MARKERS = [
  {
    time: 62.22,
    text: CustomerMarkers.SUMMARY,
  },
  {
    time: 69.2,
    text: CustomerMarkers.SUMMARY_END,
  },
];
